<template>
<div class="h100vh-140">
    <div class="h-wrapper-680">
      <div class="h-dialogContainer">
        <form id="accountForm">
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Lic.userCount')}}:</div>
                <div class="e-input-group e-control-wrapper">
                  <input class="e-control e-textbox e-lib e-input"  id="userCount" name="userCount" v-model="license.userCount" :disabled="true"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Lic.nbi')}}:</div>
                <div class="e-input-group e-control-wrapper">
                  <input class="e-control e-textbox e-lib e-input"  id="nbi" name="nbi" v-model="license.nbi" :disabled="true"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Lic.bsCount')}}:</div>
                <div class="e-input-group e-control-wrapper">
                  <input class="e-control e-textbox e-lib e-input"  id="bsCount" name="bsCount" v-model="license.bsCount" :disabled="true"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="h-col-inputBox">
              <div class="h-borderBox h-blueBg">
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <!-- <div class="e-float-input"> -->
                    <div class="h-inputLit">{{$t('Security.Lic.startTime')}}</div>
                    <input class="e-input"  id="startTime" name="startTime" v-model="license.startTime" :disabled="true" />
                    <!-- </div> -->
                  </div>
                </div>
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Lic.expiredTime')}}</div>
                    <input class="e-input" id="expiredTime" name="expiredTime" v-model="license.expiredTime" :disabled="true" />
                  </div>
                </div>
                <div class="row h-row-insertBox">
                   <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Lic.curUserCount')}}</div>
                    <input class="e-input"  id="curUserCount" name="curUserCount" v-model="license.curUserCount" :disabled="true" />
                  </div>
                </div>
                <div class="row h-row-insertBox">
                   <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Lic.curBsCount')}}</div>
                    <input class="e-input"  id="curBsCount" name="curBsCount" v-model="license.curBsCount" :disabled="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>


</template>
<script>
export default {
  name: 'NmsLicense',
  data() {
    return {
      locale: 'zh',
      items: [],
      license :{
        startTime:'',
        expiredTime:'',
        userCount:'',
        nbi:'',
        bsCount:'',
        curBsCount:0,
        curUserCount:0
      }

    }
  },
  methods: {
    findNmsLicense() {
      const url = '/lte/ems/license/findNMSLicense';
      let That = this;
      this.$axios.get(url, {}).then(response => {
        try {
          let json = response.data.JsonStr;
          let lic = JSON.parse(json);
          console.log("--------",lic)
          That.items = lic.lic.ne.Item;
          That.license.bsCount =response.data.bsLimit ;
          That.license.startTime=response.data.startTime;
          That.license.expiredTime=response.data.expiredTime;
          That.license.userCount=response.data.userLimit;
          That.license.nbi=this.getSnmpSwtich(response.data.nbi_snmp_switch);
        } catch(error) {
          console.log(error)
        }
      })
    },
    getSnmpSwtich(args){
       if(this.locale =='zh'){
          return args == 1 ? '可用' :'不可用';
       }else{
          return args == 1 ? 'available' :'Not Available';
       }
    },

    getCurrentBs(){
      this.axios.get('/lte/ems/auth/queryAllNodesByAuth').then(res => {
         this.license.curBsCount = res.data.Equipment.length;
      });
    },
     getCurrentUser(){
      this.axios.get('/lte/ems/user/getCurentUserCount').then(res => {
         this.license.curUserCount = res.data;
      });
    }
  },
  mounted() {
    this.locale = localStorage.getItem("locale");
    this.findNmsLicense();
    this.getCurrentBs();
    this.getCurrentUser();
  }
}
</script>
<style scoped>
  .license_box{
    width: 70%;
    margin: 10px 15%;
  }
</style>
